import React from 'react';

const GearPage = () => {
  return (
    <div className="container page-padding">
      <h1>Scuba Gear</h1>
      <p>Find the perfect equipment for your diving adventures.</p>
    </div>
  );
};

export default GearPage;
